import { Controller } from "@hotwired/stimulus";

export default class CampaignFormController extends Controller {
  static values = {};

  static targets = ["adPosition"];

  initialize() {}

  connect() {
    console.debug("CampaignFormController connected");
    this.updateAdPositions();
  }

  disconnect() {}

  addItem(event) {
    console.debug("CampaignFormController addItem", event.detail);

    const lastElement = event.detail.insertedElement;
    this.updateAdPositions();

    if (lastElement !== null) {
      lastElement.scrollIntoView({ behavior: "smooth" });

      const nameField = lastElement.querySelector('input[name$="[name]"]');
      if (nameField) {
        nameField.focus();
      }
    }
  }

  updateAdPositions() {
    this.adPositionTargets.forEach((adPosition, index) => {
      adPosition.textContent = index + 1;
    });
  }

  removeItem(event) {
    console.debug("CampaignFormController removeItem", event.detail);

    if (event.detail.isNewRecord) {
      return;
    }

    this.updateAdPositions();

    const wrapper = event.detail.removedElement;
    const fields = [];

    // Find the hidden ID field within the removed element
    const idField = wrapper.querySelector('input[name$="[id]"]');
    if (idField) {
      console.debug("Found ID field:", idField.value);
    }

    const imageSrcField = wrapper.querySelector('input[name$="[image_src]"]');
    if (imageSrcField) {
      console.debug("Found image_src field:", imageSrcField.value);
      fields.push(imageSrcField);
    }

    const linkHrefField = wrapper.querySelector('input[name$="[link_href]"]');
    if (linkHrefField) {
      console.debug("Found link_href field:", linkHrefField.value);
      fields.push(linkHrefField);
    }

    const sizeField = wrapper.querySelector('select[name$="[size]"]');
    if (sizeField) {
      console.debug("Found size field:", sizeField.value);
      fields.push(sizeField);
    }

    const placementField = wrapper.querySelector('select[name$="[placement]"]');
    if (placementField) {
      console.debug("Found placement field:", placementField.value);
      fields.push(placementField);
    }

    const nameField = wrapper.querySelector('input[name$="[name]"]');
    if (nameField) {
      console.debug("Found name field:", nameField.value);
      fields.push(nameField);
    }

    fields.forEach((field) => {
      console.debug(
        "Set as not required field:",
        field.getAttribute("required"),
        field.name
      );
      field.removeAttribute("required");
    });
  }
}
